import { getCurrentInstance, ref, computed, watch } from "vue";
import { isVue2 } from "vue-demi";
import DOMPurify from "dompurify";
function useSanitizeProp() {
  function createSanitizeProp2(defaultValue = true) {
    return {
      sanitize: {
        type: Boolean,
        default: defaultValue
      }
    };
  }
  return {
    createSanitizeProp: createSanitizeProp2
  };
}
function useSanitize(props) {
  function checkIfContainsHtml(value) {
    return /<([a-zA-Z][\s\S]*?)>/i.test(value);
  }
  function sanitizeValue(value) {
    if (typeof value === "string" && checkIfContainsHtml(value) && (props == null ? void 0 : props.sanitize)) {
      return DOMPurify.sanitize(value);
    }
    return value;
  }
  return {
    sanitizeValue
  };
}
const { createSanitizeProp } = useSanitizeProp();
function useVModel() {
  function createVModelProp(type = String, defaultValue = "") {
    return {
      modelValue: {
        type,
        default: defaultValue
      },
      ...createSanitizeProp()
    };
  }
  function setupVModel(props, emit, modelValuePropVue3 = "modelValue", modelEventVue2 = "input", modelValuePropVue2 = "value") {
    var _a, _b;
    let modelPropName = modelValuePropVue3;
    let modelEventName = `update:${modelPropName}`;
    const { sanitizeValue } = useSanitize(props);
    if (isVue2) {
      const vm = getCurrentInstance();
      const modelOptions = (_b = (_a = vm == null ? void 0 : vm.proxy) == null ? void 0 : _a.$options) == null ? void 0 : _b.model;
      modelEventName = (modelOptions == null ? void 0 : modelOptions.event) || modelEventVue2;
      modelPropName = (modelOptions == null ? void 0 : modelOptions.prop) || modelValuePropVue2;
    }
    const dataValue = ref(sanitizeValue(props[modelPropName]));
    const data = computed({
      get: () => dataValue.value,
      set: (value) => {
        dataValue.value = sanitizeValue(value);
        emit(modelEventName, dataValue.value);
      }
    });
    watch(
      () => props[modelPropName],
      (newValue) => {
        dataValue.value = sanitizeValue(newValue);
      }
    );
    return { data, modelPropName, modelEventName };
  }
  return {
    createVModelProp,
    setupVModel
  };
}
export {
  useVModel as u
};
